import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppSettingsResolver } from '@commoncore/resolvers/appsettings.resolver';
import { FileOperationsResolver } from '@commoncore/resolvers/file-operations.resolver';
import { AuthGuard } from '@mainrepo/app/core/guards/auth.guard';
import { HomeComponent } from './home.component';

const routes: Routes = [
  { 
    path: '',
    component: HomeComponent,
    children:[
      { path: 'trash',
        canMatch:[AuthGuard],
        data:{showSearch:false,emptyTabViewRequiresMenu:true},
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadComponent: () => import('@mainrepo-standalone/trash/trash.component').then(m => m.TrashComponent)
      },
      { path: 'profile',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/profile/profile.module').then(m => m.ProfileModule)
      },
      { path: 'userprofile',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/profile/profile.module').then(m => m.ProfileModule)
      },
      { path: 'favorites',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo-standalone-routes/favorites-routes').then(m => m.FAVORITES_ROUTES)
      },
      { path: 'contacts',
        canMatch:[AuthGuard],
        data:{showSearch:false, showContactSearch: true},
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadComponent: () => import('@mainrepo-standalone/contacts/contacts.component').then(mod => mod.ContactsComponent)
      },
      { path: 'filter',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo-standalone-routes/recents-routes').then(m => m.RECENTS_ROUTES)
      },
      { path: 'webview',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadComponent: () => import('@common-standalone/webview/webview.component').then(m => m.WebviewComponent)
      },
      { path: 'shared',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo-standalone-routes/enhanced-share-routes').then(m => m.ENHANCED_SHARE_ROUTES)
      },
      { path: 'people',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/people/people.module').then(m => m.PeopleModule)
      },
      { path: 'places',
      canMatch:[AuthGuard],
      resolve: { FileOperationsResolver,AppSettingsResolver },
      loadChildren: () => import('@mainrepo/app/modules/places/places.module').then(m => m.PlacesModule)
      },
      { path: 'orderhistory',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadComponent: () => import('@mainrepo-standalone/paid-plans/order-history/order-history.component').then(m => m.OrderHistoryComponent)
      },
      { path: 'buystorage',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadComponent: () => import('@mainrepo-standalone/paid-plans/buy-plan/buy-plan.component').then(m => m.BuyPlanComponent)
      },
      {
        path:'albums',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/albums/albums.module').then(m => m.AlbumsModule)
      },
      { 
        path: 'search',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo-standalone-routes/advanced-search-routes').then(m => m.ADVANCED_SEARCH_ROUTES)
      },
      // { 
      //   path: 'searchdetails',
      //   canMatch:[AuthGuard],
      //   data:{disable2FA:true},
      //   resolve: { FileOperationsResolver,AppSettingsResolver },
      //   loadComponent: () => import('@mainrepo-standalone/sematic-search-status-details/sematic-search-status-details.component').then(m => m.SematicSearchStatusDetailsComponent)
      // },
      { path: 'familyshare',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/familyshare/familyshare.module').then(m => m.FamilyshareModule)
      },
      { path: 'dataexport',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/data-export/data-export.module').then(m => m.DataExportModule)
      },
      { path: 'teamfolder',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo-standalone-routes/team-folder-operations-routes').then(m => m.TEAM_FOLDER_OPERATIONS_ROUTES)
      },
      { path: 'teamfolders',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/team-folders/team-folders.module').then(m => m.TeamFoldersModule)
      },
      { path: 'privatefolder',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/private-folder/private-folder.module').then(m => m.PrivateFolderModule)
      },
      { path: 'memory',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/standalone-routes/memory-routes').then(m => m.MEMORY_ROUTES)
      },
      { path: 'cloudbridge',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/cloud-bridge/cloud-bridge.module').then(m => m.CloudBridgeModule)
      },
      { path: 'ioscloudbridge',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/cloud-bridge/cloud-bridge.module').then(m => m.CloudBridgeModule)
      },
      { path: 'home',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/home-screen/home-screen.module').then(m => m.HomeScreenModule)
      },
      { path: 'digilocker',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/modules/digilocker/digilocker.module').then(m => m.DigilockerModule)
      },
      { path: 'jpai',
        canMatch: [AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/standalone-routes/jio-phone-call-ai-routes').then(m => m.JIO_PHONE_CALL_ROUTES)
      },
      { path: '',
        canMatch:[AuthGuard],
        resolve: { FileOperationsResolver,AppSettingsResolver },
        loadChildren: () => import('@mainrepo/app/standalone-routes/my-files-routes').then(m => m.MY_FILES_ROUTES)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
